// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-jhs-free-preview-certificate-canvas[data-v-c4d1f649]{width:100%}", ""]);
// Exports
module.exports = exports;
